import { BaseEntity } from "yt-ng-framework";

export class TrosakDokumentStavka extends BaseEntity{
    constructor(){
        super();
    }    

    TrosakDokumentID: number = null;
    VrstaTroskaID: number = null;
    Iznos: number = null;
    NemaPravoOdbit: boolean = null;
    OrgJedID: number = null;
    Opis: string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.TrosakDokumentID = input.TrosakDokumentID;
        this.VrstaTroskaID = input.VrstaTroskaID;
        this.Iznos = input.Iznos;
        this.NemaPravoOdbit = input.NemaPravoOdbit;
        this.OrgJedID = input.OrgJedID;
        this.Opis = input.Opis;
        return this;
    }

    Serialize(input:TrosakDokumentStavka){
        return input;
    }
}